import { z } from 'zod';
import { oneOf, pageNum, str } from '../../navigation/searchParams';

/**
 * `?conversation=<id>` opens that conversation's detail panel (the email
 * "View the call" links); the rest are the list's page and filters.
 */
export const conversationsSearch = z.object({
  conversation: str,
  page: pageNum,
  agent: str,
  channel: str,
  status: str,
  outcome: str,
  from: str,
  to: str,
  phone: str,
  filters: oneOf(['open']),
});
